import HomeTwoToneIcon from '@mui/icons-material/HomeTwoTone';
import GroupAddTwoToneIcon from '@mui/icons-material/GroupAddTwoTone';
import AssignmentIndTwoToneIcon from '@mui/icons-material/AssignmentIndTwoTone';
import AssessmentIcon from '@mui/icons-material/Assessment';
import { IUser } from 'src/Shared/Interfaces';
import { Roles } from 'src/Modules/Company/Enums/Roles.enum';

type Tab = {
  name: string;
  icons: any;
  link: string;
  permission: boolean;
  showProspectsBadge?: boolean;
};

export const Tabs: (isGranted: (string) => boolean) => Tab[] = (isGranted) => [
  {
    name: "Home",
    icons: <HomeTwoToneIcon />,
    link: "company",
    permission: true
  },
  {
    name: "Prospects",
    icons: <GroupAddTwoToneIcon />,
    link: "company/prospects",
    permission: true,
    showProspectsBadge: true
  },
  {
    name: "My Actions",
    icons: <AssignmentIndTwoToneIcon />,
    link: "assigned-actions",
    permission: true
  },
  {
    name: "SLA Reporting",
    icons: <AssessmentIcon />,
    link: "company/sla-reporting",
    permission: isGranted("CRM.SlaReporting")
  },
];
